module.exports = __webpack_public_path__ + "img/transaction-black.d8c2bff1.svg";